import { render, staticRenderFns } from "./carousel-item.vue?vue&type=template&id=f65c5784&scoped=true"
import script from "./carousel-item.vue?vue&type=script&lang=js"
export * from "./carousel-item.vue?vue&type=script&lang=js"
import style0 from "./carousel-item.vue?vue&type=style&index=0&id=f65c5784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65c5784",
  null
  
)

export default component.exports